export default __webpack_public_path__ + "static/media/who_we_are_image.b38f3aff.svg";